/**
 * Created by r4zi4l on 02.04.2021
 */

const ThirdElement = function (unit, options) {
    UnitComponent.call(this, unit);

    this.type = options.type || ThirdElement.TYPE_RUBY;
    this.prize = options.prize;
    if (options.prizeCode !== undefined && options.prizeStage !== undefined) {
        this.prize = {
            code: String.fromCharCode(options.prizeCode),
            stage: options.prizeStage
        };
    }

    const config = this.config = ThirdElement.GetConfig(this.type, this.prize);

    if (config.price === undefined) {
        this.price = Math.max(300, 300 + (this.prize.stage - 6) * 200);
    } else {
        this.price = config.price;
    }

    this.timeStart = Date.now();

    this.duration = options.time !== undefined ? options.time : cleverapps.parseInterval(config.duration) + cleverapps.parseInterval(ThirdElement.APPEARANCE_TIME);
    this.timeout = new cleverapps.LongTimeout(this.reject.bind(this), this.duration);

    this.watching = false;

    if (config.usesAd) {
        cleverapps.adsLimits.watch(AdsLimits.TYPES.THIRD_ELEMENT_CREATE);
        cleverapps.rewardedAdsManager.onRewardedRefresh(this.changeRewardedState.bind(this), this);
    }

    if (config.timeout) {
        cleverapps.dataLoader.save(DataLoader.TYPES.THIRD_ELEMENT_LAST_TIME, this.timeStart);
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.THIRD_ELEMENT_COUNT + this.type);
};

ThirdElement.prototype = Object.create(UnitComponent.prototype);
ThirdElement.prototype.constructor = ThirdElement;

ThirdElement.prototype.onAppearance = function () {
    if (this.view) {
        if (["mergecraft", "hustlemerge"].indexOf(cleverapps.config.name) !== -1) {
            this.view.helicopterAppearance();
        } else if (["ladacha", "garden"].includes(cleverapps.config.name)) {
            this.view.bubbleAppearance();
        } else {
            this.view.planeAppearance();
        }
    }
};

ThirdElement.prototype.save = function (data) {
    data.time = this.timeout.getTimeLeft();
    data.type = this.type;
    data.prizeStage = this.prize.stage;
    data.prizeCode = this.prize.code.charCodeAt(0);

    return data;
};

ThirdElement.prototype.onDestruction = function () {
    if (this.view) {
        this.view.playDestruction();
    }
};

ThirdElement.prototype.onBuying = function (unit) {
    if (this.view) {
        this.view.playBuying(unit);
    }
};

ThirdElement.GetConfig = function (type, unit) {
    let config = ThirdElement.CONFIG[type];
    if (!config) {
        return;
    }

    const familyType = Families[unit.code].type;
    if (type === ThirdElement.TYPE_ANIMALS) {
        config = config[familyType] && config[familyType][unit.stage];
    } else if (config.customPrices && config.customPrices[familyType]) {
        config = { ...config, price: config.customPrices[familyType][unit.stage] };
    }

    return config;
};

ThirdElement.IsAvailable = function (type, unit) {
    if (cleverapps.gameModes.skipThirdElement) {
        return false;
    }

    const family = Families[unit.code];
    const unitType = family.type;
    const config = ThirdElement.GetConfig(type, unit);
    if (!config) {
        return false;
    }

    if (type === ThirdElement.TYPE_ANIMALS) {
        if (cleverapps.unitsLibrary.isOpened({ code: unit.code, stage: family.units.length - 1 })) {
            return false;
        }
    }

    if (config.available && !cleverapps.user.checkAvailable(config.available)) {
        return false;
    }

    if (config.types && !config.types.some((configType) => unitType === cleverapps.unitsLibrary.getExpeditionUnitType(configType))) {
        return false;
    }

    if (config.usesAd && cleverapps.adsLimits.state(AdsLimits.TYPES.THIRD_ELEMENT_CREATE) !== AdsLimits.STATE_READY) {
        return false;
    }
    if (config.timeout && cleverapps.dataLoader.load(DataLoader.TYPES.THIRD_ELEMENT_LAST_TIME) + cleverapps.parseInterval(config.timeout) > Date.now()) {
        return false;
    }
    if (!config.types) {
        return true;
    }

    return config.types.some((configType) => {
        if (unitType !== cleverapps.unitsLibrary.getExpeditionUnitType(configType)) {
            return false;
        }
        const usesAd = config.usesAd;

        if (configType === "hero") {
            if (usesAd) {
                return unit.stage >= 1 && unit.stage < Math.min(4, family.units.length - 1);
            }
            if (unitType === "hero") {
                return unit.stage >= 6 && unit.stage >= family.units.length - 3 && unit.stage < family.units.length - 1;
            }
            return unit.stage >= 5 && unit.stage >= family.units.length - 3 && unit.stage < family.units.length - 1;
        }

        const hasTutorial = typeof MergeTutorials !== "undefined" && MergeTutorials[Unit.GetKey(unit)];
        if (cleverapps.unitsLibrary.isOpened(unit) || !hasTutorial) {
            const unitFilter = config.unitFilter && config.unitFilter[unitType];
            if (unitFilter) {
                return unitFilter(unit);
            }

            if (usesAd) {
                return unit.stage >= 2 && unit.stage < Math.min(5, family.units.length - 1);
            }
            if (unitType === "resource") {
                return unit.stage >= 6 && unit.stage >= family.units.length - 4 && unit.stage < family.units.length - 2;
            }
            if (unitType === "rpresource") {
                return unit.stage === family.units.length - 1;
            }
            return unit.stage >= 5 && unit.stage >= family.units.length - 3 && unit.stage < family.units.length - 1;
        }

        return false;
    });
};

ThirdElement.prototype.isMovable = function () {
    return false;
};

ThirdElement.prototype.changeRewardedState = function () {
    if (!connector.ads.isRewardedAvailable && !this.watching) {
        this.reject();
    }
};

ThirdElement.prototype.destructor = function () {
    clearTimeout(this.timeout);
    runCleaners(this);
};

ThirdElement.prototype.getTimeLeft = function () {
    return Math.max(0, this.timeStart + this.duration - Date.now());
};

ThirdElement.prototype.accept = function () {
    if (this.collected) {
        return;
    }

    let x = this.unit.x;
    let y = this.unit.y;
    const mapUnit = Map2d.currentMap.getUnit(x, y);

    if (mapUnit === this.unit) {
        this.unit.liftUnitFromMap();
    } else if (mapUnit) {
        const cell = Map2d.currentMap.findEmptySlot(x, y);
        if (!cell) {
            return;
        }
        x = cell.x;
        y = cell.y;
    }

    const unit = new Unit(this.prize);
    unit.setPosition(x, y);
    Map2d.currentMap.add(Map2d.LAYER_UNITS, x, y, unit);
    Map2d.currentMap.onAddUnit(x, y, unit);
    Map2d.currentMap.onUnitAvailable(unit);
    this.onBuying(unit);

    this.collected = true;

    if (mapUnit === this.unit) {
        this.unit.remove(true);
    }

    const data = { unit, affected: this.unit };
    Map2d.mapEvent(Map2d.SPAWN, data);
    cleverapps.tutorial.trigger(Map2d.SPAWN, data);
};

ThirdElement.prototype.reject = function () {
    this.onDestruction();
    this.unit.onDestruction();
    this.unit.remove(true);
};

ThirdElement.prototype.getProduct = function () {
    return Product.CreateByHardPrice(this.price, {
        type: "third_element",
        expedition: cleverapps.meta.selectedLocationId()
    }, this.type === ThirdElement.TYPE_PASS_FINISH ? ["kit3", "kit10", "kit50"] : []);
};

ThirdElement.prototype.buy = function (callback) {
    const product = this.getProduct();

    if (product) {
        product.buy((success) => {
            if (success) {
                this.accept();
            }
            callback(success);
        });
    } else {
        callback(false);
    }
};

ThirdElement.prototype.watch = function () {
    this.watching = true;
    cleverapps.rewardedAdsManager.playRewarded(
        AdsLimits.TYPES.THIRD_ELEMENT,
        () => {
            this.watching = false;
            this.accept();
        },
        () => {
            this.watching = false;
            this.reject();
        }
    );
};

ThirdElement.prototype.handleClick = function () {
    if (this.config.usesAd !== undefined) {
        this.watch();
        return true;
    }

    cleverapps.focusManager.display({
        focus: "thirdElementWindow",
        control: "MenuBarGoldItem",
        actions: [
            function (f) {
                setTimeout(f, 300);
            },

            function (f) {
                new ThirdElementWindow(this);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this)
        ]
    });

    return true;
};

ThirdElement.TYPE_RUBY = 1;
ThirdElement.TYPE_ADS = 2;
ThirdElement.TYPE_PASS_FINISH_LEGACY = 3;
ThirdElement.TYPE_PASS_FINISH = 4;
ThirdElement.TYPE_ANIMALS = 6;

ThirdElement.CONFIG = {};

ThirdElement.CONFIG[ThirdElement.TYPE_RUBY] = {
    duration: "5 minutes",
    timeout: "3 hours",
    types: ["hero", "resource"],
    customPrices: {
        rpresource: { 3: 29 }
    }
};

ThirdElement.CONFIG[ThirdElement.TYPE_ADS] = {
    duration: "1 minutes",
    usesAd: true,
    types: ["hero", "resource"]
};

ThirdElement.CONFIG[ThirdElement.TYPE_PASS_FINISH] = ThirdElement.CONFIG[ThirdElement.TYPE_PASS_FINISH_LEGACY] = {
    duration: "5 minutes",
    price: 299
};

ThirdElement.ANIMALS_TIMEOUT = cleverapps.config.debugMode ? "10 seconds" : "24 hours";

ThirdElement.CONFIG[ThirdElement.TYPE_ANIMALS] = {
    clpet: {
        3: {
            duration: "5 minutes",
            timeout: ThirdElement.ANIMALS_TIMEOUT,
            price: 165,
            available: cleverapps.config.availables.ANIMALS_THIRD_ELEMENT
        }
    },
    clpetrare: {
        4: {
            duration: "5 minutes",
            timeout: ThirdElement.ANIMALS_TIMEOUT,
            price: 350,
            available: cleverapps.config.availables.ANIMALS_THIRD_ELEMENT
        }
    },
    clpetlegend: {
        4: {
            duration: "5 minutes",
            timeout: ThirdElement.ANIMALS_TIMEOUT,
            price: 890,
            available: cleverapps.config.availables.ANIMALS_THIRD_ELEMENT
        },
        5: {
            duration: "5 minutes",
            timeout: ThirdElement.ANIMALS_TIMEOUT,
            price: 1490,
            available: cleverapps.config.availables.ANIMALS_THIRD_ELEMENT
        }
    }
};

ThirdElement.APPEARANCE_TIME = cleverapps.config.name === "mergecraft" ? "4 seconds" : "2 seconds";
